/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import {combineReducers} from 'redux';
import UIStore from '../redux/UIStore';
import appReducer from './appReducer';
import authReducer from './authReducer';
import ccstorageReducer from './ccstorageReducer';
import featureReducer from './featurerReducer';
import predictReducer from './predictReducer';
import profileReducer from './profileReducer';
import saveToLibraryReducer from './saveToLibraryReducer';
import searchReducer from './searchReducer';
import ucsReducer from './userContentReducer';
import appHomeReducer from './appHomeReducer';
import notificationsReducer from './notificationsReducer';

export default combineReducers({
	auth: authReducer,
	app: appReducer,
	search: searchReducer,
	ccstorage: ccstorageReducer,
	profile: profileReducer,
	features: featureReducer,
	predict: predictReducer,
	uistore: UIStore.reducer,
	saveToLibrary: saveToLibraryReducer,
	userContent: ucsReducer,
	appHome: appHomeReducer,
	appNotifications: notificationsReducer,
});
